import { STEAM_WEB_API_TICKET_IDENTITY } from '@repo/sdk'

export function isSteamClient(): boolean {
  if (typeof window === 'undefined')
    return false
  return window.mentissSteam?.isSteam === true
    || (typeof navigator !== 'undefined' && navigator.userAgent.includes('MentissSteam'))
}

export function getSteamBridge(): MentissSteam | null {
  return window.mentissSteam ?? null
}

export function openExternalUrl(url: string): void {
  if (isSteamClient()) {
    window.mentissSteam!.openOverlayToUrl(url)
  }
  else {
    window.open(url, '_blank')
  }
}

export async function steamAutoAuth(): Promise<void> {
  const steam = getSteamBridge()
  if (!steam)
    return

  if (sessionStorage.getItem('mentiss_steam_authed') === 'true')
    return
  sessionStorage.setItem('mentiss_steam_authed', 'true')

  try {
    console.log('[Steam] Auto-authenticating...')
    const [ticket, steamId, displayName] = await Promise.all([
      steam.getAuthSessionTicket(STEAM_WEB_API_TICKET_IDENTITY),
      steam.getSteamId(),
      steam.getDisplayName(),
    ])

    const { API_URL } = await import('./constants')
    const response = await fetch(`${API_URL}/api/steam/auth`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ ticket, steamId, displayName }),
    })

    if (!response.ok) {
      const error = await response.text()
      console.error('[Steam] Auth failed:', response.status, error)
      sessionStorage.removeItem('mentiss_steam_authed')
      return
    }

    const data = await response.json()
    console.log('[Steam] Authenticated as user', data.userId)

    window.location.reload()
  }
  catch (err) {
    console.error('[Steam] Auto-auth error:', err)
    sessionStorage.removeItem('mentiss_steam_authed')
  }
}
